import { Component, HostBinding } from '@angular/core';
import {
  trigger,
  transition,
  state,
  style,
  animate
} from '@angular/animations';

const animationStyle = '250ms ease-in-out';

@Component({
  selector: 'muni-gameday-gameday-header-sidebar',
  templateUrl: './sidebar.template.html',
  animations: [
    trigger('slideInOut', [
      state('*', style({ transform: 'translateX(0)', opacity: 1 })),
      transition('void => *', [
        style({
          transform: 'translateX(100%)',
          opacity: 0
        }),
        animate(animationStyle)
      ]),
      transition('* => void', [
        animate(
          animationStyle,
          style({
            transform: 'translateX(100%)',
            opacity: 0
          })
        )
      ])
    ])
  ],
  standalone: false
})
export class HeaderSidebarComponent {
  @HostBinding('@slideInOut')
  public readonly slideInOut: boolean = true;

  @HostBinding('style.display')
  public readonly display: string = 'block';

  @HostBinding('style.float')
  public readonly float: string = 'right';
}
